import InputAmount from 'components/InputAmount'
import { add, subtract } from 'lodash'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Ether, TokenSymbol } from 'types'
import { PlaceOrderCurrencySelection } from './CurrencySelection'
import { AddButton, SubtractButton } from './styles'
import { StyledControlInput } from '../../styles/Control'
import { MaxButton } from './MaxButton'
import { useSetAtom } from 'jotai'
import { perpOrderPercentAtom } from 'views/Perp/CreateOrder/AmountPercent/atoms'
import { orderPercentAtom } from 'views/Spot/CreateOrder/AmountPercent/atoms'

export const BaseCurrencyInput = memo<{
  currentAmount: Ether
  baseCurrency: TokenSymbol
  quoteCurrency: TokenSymbol
  minimumIncrement: Ether
  onChangeAmount: (amount: Ether) => void
  onClickMax: () => void
}>(
  ({
    currentAmount,
    baseCurrency,
    quoteCurrency,
    minimumIncrement,
    onChangeAmount,
    onClickMax,
  }) => {
    const { t } = useTranslation()
    const setSpotPercent = useSetAtom(orderPercentAtom)
    const setPerpPercent = useSetAtom(perpOrderPercentAtom)
    return (
      <StyledControlInput>
        {/* <SubtractButton
          onClick={() =>
            onChangeAmount(
              subtract(+currentAmount, +minimumIncrement).toString(),
            )
          }
        >
          -
        </SubtractButton> */}
        <InputAmount
          value={currentAmount}
          placeholder={t('create-order-amount', { defaultValue: 'Amount' })}
          onInput={onChangeAmount}
          onFocus={() => {
            setSpotPercent(0)
            setPerpPercent(0)
          }}
        />
        <div className="input-border" />
        <MaxButton onClick={onClickMax} />
        <PlaceOrderCurrencySelection
          currentCurrency={baseCurrency}
          baseCurrency={baseCurrency}
          quoteCurrency={quoteCurrency}
        />
        {/* <AddButton
          onClick={() =>
            onChangeAmount(add(+currentAmount, +minimumIncrement).toString())
          }
        >
          +
        </AddButton> */}
      </StyledControlInput>
    )
  },
)
